import React from 'react';
import { classNames } from '../../../utils/style';
import { AdditionalPrice } from '../AdditionalPrice';

export const PricePerEmployeeBig = ({
  pricePerEmployee,
  currencyFirst,
  currency,
  previousPricePerEmployee,
  pricePerEmployeeLabel,
  displayEmptyLines,
}: any) => {
  return (
    pricePerEmployee && (
      <div>
        <div
          className={classNames(
            'font-serif',
            'font-bold max-h-[48px]',
            'flex items-baseline mb-16',
          )}
        >
          {currencyFirst && (
            <span className={classNames('font-serif text-24', 'font-bold')}>
              {currency}
            </span>
          )}
          <span className="text-48 leading-48">{pricePerEmployee}</span>
          <span
            className={classNames('pl-[5px] font-serif text-24', 'font-bold')}
          >
            {!currencyFirst && <span>{currency}</span>}
            {previousPricePerEmployee && (
              <span className="text-silver-300 ml-[10px] line-through">
                {currencyFirst && <span>{currency}</span>}
                {previousPricePerEmployee}
                {!currencyFirst && <span>{currency}</span>}
              </span>
            )}
          </span>
        </div>

        <AdditionalPrice
          name="pricePerEmployeeLabel"
          display={pricePerEmployeeLabel}
          displayEmptyLines={displayEmptyLines}
          className={classNames(
            'pricePerEmployeeLabel text-neutral-301 font-semibold',
          )}
        >
          {pricePerEmployeeLabel}
        </AdditionalPrice>
      </div>
    )
  );
};
